// extracted by mini-css-extract-plugin
export default {"initialLoading":"loading_initialLoading__F7rST","loading":"loading_loading__zdVwF","fullPage":"loading_fullPage__D2k96"};